<template>
  <div class="page-pas">
    <el-form ref="form" :model="value">
      <el-form-item label="原密码：">
        <el-input type="password" v-model="value.user_name" style="width:250px" :maxlength="8"  show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="新密码：">
        <el-input type="password" v-model="value.passwors" style="width:250px" :maxlength="8"  show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="两次输入新密码：">
        <el-input type="password" v-model="value.newPasswors" style="width:250px" :maxlength="8"  show-word-limit></el-input>
      </el-form-item>
      <el-form-item>
        <div class="btn-box">
          <el-button type="primary" @click="submitForm">确定修改</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updatapwd } from "@/api/api";
export default {
  data() {
    return {
      value: {
        user_name: "",
        passwors: "",
        newPasswors: ""
      }
    };
  },
  methods: {
    //确定修改
    submitForm() {
      this.passwordAuthentication();
    },
    //表单验证
    passwordAuthentication() {
      if (this.value.user_name == "") {
        this.$message.error("原密码不能为空");
      } else if (this.value.passwors == "") {
        this.$message.error("新密码不能为空");
      } else if (this.value.newPasswors == "") {
        this.$message.error("确定密码不能为空");
      } else if (this.value.passwors !== this.value.newPasswors) {
        this.$message.error("两次密码不一样");
      } else {
        let pam = {
          oPassword: this.value.user_name,
          newPassword1: this.value.passwors,
          newPassword2: this.value.newPasswors
        };
        updatapwd(pam).then(res => {
          if (res.errno == 0) {
            this.$message(res.data.msg);
          } else {
            this.$message.error(res.errmsg);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-pas {
  .btn-box {
    margin: 30px 0 0 128px;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?2112fe6c